'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { Book } from '@/components/ui/book';
import { useIsMobile } from '@/hooks/useIsMobile';
interface BookWithContainerProps {
  title: string;
  author: string;
  coverImage?: string;
  size?: number;
  inline?: boolean;
}
export default function BookWithContainer(t0) {
  const $ = _c(30);
  const {
    title,
    author,
    coverImage,
    size: explicitSize,
    inline: t1
  } = t0;
  const inline = t1 === undefined ? false : t1;
  const isMobile = useIsMobile();
  const size = explicitSize ?? (isMobile ? 280 : 400);
  const bookWidth = size * 0.5;
  const t2 = inline ? "relative" : "flex h-screen items-center justify-center";
  const t3 = size * 0.2;
  let t4;
  if ($[0] !== size || $[1] !== t3) {
    t4 = {
      width: size,
      height: size,
      borderRadius: t3
    };
    $[0] = size;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== bookWidth || $[4] !== coverImage || $[5] !== title) {
    t5 = coverImage ? <Image src={coverImage} alt={title} width={bookWidth} height={bookWidth * 1.5} sizes="(max-width: 768px) 140px, 200px" className="size-full object-cover" /> : undefined;
    $[3] = bookWidth;
    $[4] = coverImage;
    $[5] = title;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== author || $[8] !== coverImage || $[9] !== title) {
    t6 = !coverImage && <div className="flex h-full flex-col justify-center p-2 text-white"><p className="text-xs leading-tight font-semibold">{title}</p><p className="mt-0.5 text-[10px] opacity-80">{author}</p></div>;
    $[7] = author;
    $[8] = coverImage;
    $[9] = title;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== bookWidth || $[12] !== coverImage || $[13] !== t5 || $[14] !== t6) {
    t7 = <Book color="#2b2f38" width={bookWidth} depth={4} backImage={coverImage} illustration={t5}>{t6}</Book>;
    $[11] = bookWidth;
    $[12] = coverImage;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== title) {
    t8 = <h3 className="text-2xl text-black/90 dark:text-white/90">{title}</h3>;
    $[16] = title;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== author) {
    t9 = <p className="mt-1 text-xl text-black/[32%] dark:text-white/[32%]">{author}</p>;
    $[18] = author;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <div className="mt-6 text-center">{t8}{t9}</div>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t4 || $[25] !== t7) {
    t11 = <div style={t4} className="relative flex flex-col items-center justify-center overflow-hidden border border-[#cacaca] bg-[#E3E3E3] p-10 pt-12 font-medium tracking-tight shadow-[0_3px_3px_-1.5px_rgba(0,0,0,0.06)] dark:border-[#3a3a3a] dark:bg-[#2a2a2a]">{t7}{t10}</div>;
    $[23] = t10;
    $[24] = t4;
    $[25] = t7;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t2) {
    t12 = <div className={t2}>{t11}</div>;
    $[27] = t11;
    $[28] = t2;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
}